import { render, staticRenderFns } from "./AccessibilityPlugin.vue?vue&type=template&id=20cc2b87&scoped=true"
import script from "./AccessibilityPlugin.vue?vue&type=script&lang=js"
export * from "./AccessibilityPlugin.vue?vue&type=script&lang=js"
import style0 from "./AccessibilityPlugin.vue?vue&type=style&index=0&id=20cc2b87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cc2b87",
  null
  
)

export default component.exports